import {
    EmailFieldRHF,
    LabelPosition,
    RHookFormPasswordFieldWithLabel,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface ISwipeClockSetupFieldsPanel {
}
export const SwipeClockSetupFieldsPanel: FC<
    ISwipeClockSetupFieldsPanel
> = ({ }) => {

    return (
        <>
            <RHookFormTextFieldWithLabel
                label="Accountant ID:"
                id="accountant_id"
                testId={`accountant-id`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormTextFieldWithLabel
                label="Site ID:"
                id="site_id"
                testId={`site-id`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormTextFieldWithLabel
                label="SwiperClock API Secret:"
                id="api_secret"
                testId={`swiper-clock-Api-Secret`}
                labelPosition={LabelPosition.Top}
            />
        </>
    );
};
